import { createContext, useContext, useMemo } from 'react';
import { useAudio } from './AudioContext';
import { buildDiscoveryPrompts, normalizeNowPlaying } from '../lib/nowPlayingIntelligence';

const NowPlayingContext = createContext(null);

const NowPlayingProvider = ({ children }) => {
  const { currentTrack, activeSource, isPlaying } = useAudio();
  const value = useMemo(() => {
    const media = normalizeNowPlaying(currentTrack, activeSource);
    return {
      media,
      isPlaying,
      discoveryPrompts: buildDiscoveryPrompts(media),
    };
  }, [activeSource, currentTrack, isPlaying]);

  return <NowPlayingContext.Provider value={value}>{children}</NowPlayingContext.Provider>;
};

const useNowPlaying = () => {
  const context = useContext(NowPlayingContext);
  if (!context) throw new Error('useNowPlaying must be used within NowPlayingProvider');
  return context;
};

export { NowPlayingProvider, useNowPlaying };
export default NowPlayingContext;
